// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/analytics/SecurityDetail.scss
// module id = 1293
// module chunks = 0